import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'search/reducers/root.reducer';
import { tryToGetItTab } from '../../actions/entity.actions';
import { FeatureToggleService } from 'app/services/feature-toggle.service';
import { EditionPublicationData } from '../../models/entity';

@Component({
  selector: 'app-get-it-button',
  templateUrl: './get-it-button.component.html',
  styleUrls: ['./get-it-button.component.scss'],
})
export class GetItButtonComponent {
  @Input() public resourceId: string;
  @Input() public tabName: string;
  @Input() public ariaDescribedBy = '';
  @Input() public editionPublicationData: EditionPublicationData[];

  public newEditionsUxDesignEnabled: boolean;

  public constructor(
    private readonly featureToggleService: FeatureToggleService,
    private readonly store: Store<State>,
  ) {
    this.newEditionsUxDesignEnabled = this.featureToggleService.getToggles()['VDIS-33338_2025-12-31_new_editions_UX_design'];
  }

  public onGetItRollUp(event: Event) {
    event.stopPropagation();
    this.store.dispatch(tryToGetItTab({cardInfo: {id: this.resourceId, tabName: this.tabName, editionPublicationData: this.editionPublicationData}}));
  }
}
